import { forwardRef } from 'react';
import { WeaveTheme } from '@frontend/theme';

export interface SuccessFilledSmallProps extends React.SVGProps<SVGSVGElement> {
  colors: WeaveTheme['colors'];
  primaryColor?: string;
  secondaryColor?: string;
}

const SuccessFilledSmall = forwardRef<SVGSVGElement, SuccessFilledSmallProps>(
  ({ colors, primaryColor, secondaryColor, ...props }, ref) => {
    return (
      <svg {...props} ref={ref} fill='none' viewBox='0 0 24 24'>
        <path
          fill={primaryColor ?? colors.success20}
          d='M22.5 12.004c0 5.799-4.701 10.5-10.5 10.5s-10.5-4.701-10.5-10.5c0-5.8 4.701-10.5 10.5-10.5s10.5 4.7 10.5 10.5'
        ></path>
        <path
          fill={secondaryColor ?? '#125F36'}
          fillRule='evenodd'
          d='M17.374 7.737a1.5 1.5 0 0 1 .225 2.11l-5.37 6.655a1.725 1.725 0 0 1-2.562.137l-2.052-2.051a1.5 1.5 0 0 1 2.121-2.122l1.049 1.049 4.48-5.553a1.5 1.5 0 0 1 2.109-.225'
          clipRule='evenodd'
        ></path>
      </svg>
    );
  }
);

SuccessFilledSmall.displayName = 'SuccessFilledSmall';

export default SuccessFilledSmall;
